import React from "react";

import { useTranslation } from "react-i18next";

export default function NumberInput(props: {
	totalPages: number;
	onPageChange: (newPage: number) => void;
}) {
	const { t } = useTranslation();

	const onKeyDown: React.KeyboardEventHandler<HTMLInputElement> = (e) => {
		if (e.keyCode !== 13) {
			return;
		}

		const newPage = parseInt((e.target as HTMLInputElement).value);
		if (isNaN(newPage) || newPage < 1 || newPage > props.totalPages) {
			return;
		}

		props.onPageChange(newPage);
	};

	return (
		<input
			className="pagination__input input input--sml"
			type="number"
			min="1"
			max={props.totalPages}
			onKeyDown={onKeyDown}
			placeholder={t("COMMON.PAGE_PLACE_HOLDER")}
		/>
	);
}
